import React, { useContext } from "react";
import '../styles/landing.scss';
import { useNavigate, Link } from "react-router-dom";
import { useSessionId, ThemeContext, useAuthProvider, Loader, leadAdapter } from "@cloudpremise/portal_core";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";
import Banner from "../components/Banner";
import Container from "@mui/material/Container";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";
import MDInput from "@cloudpremise/portal_core/src/themes/mui/components/MDInput";
import BookingCard from "@cloudpremise/portal_core/src/themes/mui/examples/Cards/BookingCard";
import MDTypography from "@cloudpremise/portal_core/src/themes/mui/components/MDTypography";
import LeadModal from "../components/LeadModal";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import { useIsAuthenticated } from '@azure/msal-react';
import { useMsal } from "@azure/msal-react";
import Config from "../Config";
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

const cdnUrl = Config.getCdnUrl();
const bgImage = cdnUrl + "/assets/img/main_banner.jpg";
const introBg = cdnUrl + "/assets/img/introduction_bg.jpg";
const ultimateBackendImg = cdnUrl + "/assets/img/introducing-olympus-grid.webp";
const goldbergMachineImg = cdnUrl + "/assets/img/the-evolution-of-olympus-grid.webp";
const jokerImg = cdnUrl + "/assets/img/olympus-grid-the-future.webp";
const storyImg = cdnUrl + "/assets/img/our_story.webp";

const launchFastImg = cdnUrl + "/assets/img/launch_fast.webp";
const optimizeAutomateImg = cdnUrl + "/assets/img/optimize_automate.webp";
const enterpriseGradeImg = cdnUrl + "/assets/img/enterprise_grade.webp";
const buildGrowImg = cdnUrl + "/assets/img/build_grow.webp";

declare const window: Window & typeof globalThis & {
    inlineApexAdaptor: any,
    pdfjsLib: any,
    PDFViewerApplication: any,
    getViewerConfiguration: any,
    onRegistrationFormComplete: any,
    verifyEmailRegistrationAF: any,
    onLoginFormComplete: any,
    verifyEmailLoginAF: any
}

const Landing = (props) => {
    const [ authorized, authType ] = useAuthProvider();
    const [state, setState] = React.useState({
        firstName: "",
        lastName: "",
        email: "",
        company: "",
        isSuccess: false,
        loading: false,
        errorMessage: null,
        pdfModal: false,
        pdfData: null,
        verifyCode: false,
        userId: "",
        code: "",
        identifier: "",
        login: false
    });
    const [leadModal, onLeadModal] = React.useState(false);
    const navigate = useNavigate();
    function handleChange(e, name){
        setState({
            ...state,
            [name]: e.target.value,
        });
    }
    function onSubmit(e, signup = false){
        e.preventDefault();
        const { firstName, lastName, email, company, identifier, verifyCode, code, login, userId } = state;
        if(!isFormValid()){
            return;
        }
        leadAdapter(firstName, lastName, email, company, (data) => {
            if(typeof(data) === "object" && data.hasOwnProperty("isSuccess") && data.isSuccess){
                setState({
                    ...state,
                    loading: false,
                    isSuccess: true,
                    firstName: "",
                    lastName: "",
                    email: "",
                    company: ""
                });
            }else{
                let message = 'Unable to create lead.';
                if(typeof(data) === "object" && data.hasOwnProperty("result")){
                    message = data.result;
                }
                setState({
                    ...state,
                    loading: false,
                    errorMessage: message
                });
            }
        });
        
        setState({
            ...state,
            loading: true,
            errorMessage: null
        });
    }
    function isFormValid(){
        const { email } = state;
        if(email.length > 0){
            return true;
        }
        return false;
    }
    return (
        <MDBox className="landing-page" bgColor="white">
            <Banner
                image={bgImage}
                content={
                    (
                        <Container className="text-container">
                            <Grid container justifyContent="center" alignItems="center">
                                    <Grid item xs={12} md={10} lg={8} position="relative">
                                        <h1>Olympus-Grid&trade;</h1>
                                        <p>Build faster, scale smarter, and deliver seamlessly—all on a secure, unified platform with <span className="brand-title">Olympus-Grid&trade;.</span></p>
                                        <MDButton component="a" variant="gradient" color="info" size="large" href="https://calendly.com/gregheartcloud/" target="_blank">
                                            Book a Demo
                                        </MDButton>
                                    </Grid>
                                    <Grid item xs={12} md={4} lg={4}>
                                        
                                    </Grid>
                                </Grid>
                        </Container>
                    )
                }
            />
            <MDBox className="why-container">
                <Container>
                    <Grid container justifyContent="center">
                        <Grid item xs={12} md={9} lg={9}>
                            <h3>Why Olympus-Grid&trade;?</h3>
                            <p>More than a platform—it's a revolution.</p>
                            <p><span className="brand-title">Olympus-Grid&trade;</span> is a cutting-edge, serverless technology stack built directly inside Salesforce. It empowers businesses of all sizes to launch <strong>secure, scalable, and resilient applications—without infrastructure headaches.</strong></p>
                        </Grid>
                    </Grid>
                </Container>
            </MDBox>
            <MDBox className="features-container">
                <Container>
                    <Grid container justifyContent="center">
                        <Grid item xs={12} md={4} lg={3}>
                            <span className="feature-number">1</span>
                            <h4>Built inside Salesforce for ultimate security and compliance.</h4>
                            <p><span className="brand-title">Olympus-Grid&trade;</span> operates entirely within Salesforce, ensuring that your data never leaves its secure environment. This means you benefit from Salesforce’s built-in compliance measures, including HIPAA, GDPR, and other industry standards. No external servers, no unnecessary vulnerabilities—just enterprise-grade security and peace of mind.</p>
                        </Grid>
                        <Grid item xs={12} md={4} lg={3}>
                            <span className="feature-number">2</span>
                            <h4>Serverless by design—fast, efficient, and cost-effective.</h4>
                            <p>Say goodbye to infrastructure headaches. <span className="brand-title">Olympus-Grid&trade;</span> is fully serverless, eliminating the need for expensive hardware, maintenance, or scaling concerns. Your applications run at peak efficiency, scaling automatically to handle demand without downtime. This not only reduces costs but also accelerates development, allowing your team to focus on innovation rather than operations.</p>
                        </Grid>
                        <Grid item xs={12} md={4} lg={3}>
                            <span className="feature-number">3</span>
                            <h4>Powerful API tooling for seamless integrations and automation.</h4>
                            <p><span className="brand-title">Olympus-Grid&trade;</span> is designed for a connected world. Our powerful API tools enable businesses to seamlessly integrate with third-party applications, automate workflows, and extend Salesforce’s capabilities. Whether you need to connect with payment gateways, AI models, or legacy systems, <span className="brand-title">Olympus-Grid&trade;</span> makes integrations simple, reliable, and scalable.</p>
                        </Grid>
                    </Grid>
                    <MDButton onClick={() => onLeadModal(true)} variant="gradient" color="info" size="large">
                        Learn More
                    </MDButton>
                </Container>
            </MDBox>
            <MDBox className="whoweserve-container">
                <h3>Who We Serve: From Startup to Enterprise, <span className="brand-title">Olympus-Grid&trade;</span> Scales With You</h3>
                <Container>
                    <Grid container justifyContent="center">
                        <Grid item xs={12} md={6} lg={6}>
                            <img src={launchFastImg} alt="" />
                            <div className="serve-detail">
                                <h4>Launch Fast, Iterate Faster (Startups & Innovators)</h4>
                                <p>Skip the infrastructure headaches. <span className="brand-title">Olympus-Grid&trade;</span>’s serverless architecture lets startups build, deploy, and scale directly inside Salesforce—fast, efficient, and cost-effective.</p>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={6} lg={6}>
                            <img src={optimizeAutomateImg} alt="" />
                            <div className="serve-detail">
                                <h4>Optimize & Automate (Growing Businesses)</h4>
                                <p>As your business scales, <span className="brand-title">Olympus-Grid&trade;</span> streamlines operations with powerful APIs, automation, and custom workflows—boosting efficiency without added complexity.</p>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={6} lg={6}>
                            <img src={enterpriseGradeImg} alt="" />
                            <div className="serve-detail">
                                <h4>Enterprise-Grade Performance (Large-Scale Organizations)</h4>
                                <p>Built for high-demand environments, <span className="brand-title">Olympus-Grid&trade;</span> ensures top-tier security, compliance (HIPAA, GDPR), and performance, handling millions of records seamlessly.</p>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={6} lg={6}>
                            <img src={buildGrowImg} alt="" />
                            <div className="serve-detail">
                                <h4>Built to Grow With You (Future-Proof Technology)</h4>
                                <p>Technology should adapt to you, not the other way around. <span className="brand-title">Olympus-Grid&trade;</span> evolves with your business, keeping you agile, scalable, and always ahead.</p>
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </MDBox>
            <MDBox className="intro-container">
                <Container>
                    <Grid container>
                        <Grid item xs={12} md={6} lg={5} className="intro">
                            <MDBox
                                sx={{
                                    backgroundImage: ({ palette: { gradients }, functions: { linearGradient, rgba } }) =>
                                        `${linearGradient(
                                        rgba(gradients.dark.main, 0.4),
                                        rgba(gradients.dark.state, 0.6)
                                        )}, url(${introBg})`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                }}
                            >
                                <h3>Features & Benefits</h3>
                                <p><strong>Built for Performance, Security & Scalability</strong></p>
                                <p><span className="brand-title">Olympus-Grid&trade;</span> combines the power of Salesforce-native security, serverless efficiency, and seamless automation to help businesses build, scale, and innovate without limitations. From powerful integrations to enterprise-grade compliance, every feature is designed to keep your operations running faster, smarter, and more securely.</p>
                                <MDButton component="a" variant="gradient" color="info" size="large" href="https://calendly.com/gregheartcloud/" target="_blank">
                                    Book a Demo
                                </MDButton>
                            </MDBox>
                            
                        </Grid>
                        <Grid item xs={12} md={6} lg={7}>
                            <Grid container xs={12} sm={12} md={12} lg={12} className="cards-container">
                                <Grid xs={12} md={12} lg={6}>
                                    <Grid item>
                                        {/* <svg viewBox="19.868 38.586 160.264 121.194" xmlns="http://www.w3.org/2000/svg" role="presentation">
                                            <g>
                                                <path d="M149.73 83.547c-2.538-25.284-24.211-44.961-49.73-44.961S52.808 58.263 50.269 83.547c-17.67 3.837-30.401 19.54-30.401 37.674 0 21.261 17.297 38.559 38.559 38.559h83.146c21.261 0 38.559-17.297 38.559-38.559 0-18.135-12.732-33.838-30.402-37.674zm-8.157 64.423H58.427a26.755 26.755 0 0 1-16.198-5.482l21.237-21.114 13.181 13.19 36.505-35.875 8.081 8.047 6.076-30.357-30.353 6.177 8.281 8.243-28.512 28.025-13.236-13.239-28.56 28.399a26.646 26.646 0 0 1-3.252-12.763c0-13.887 10.85-25.598 24.701-26.661l5.452-.419v-5.488l-.003-.16C61.868 67.486 78.992 50.395 100 50.395c21.047 0 38.171 17.078 38.172 38.069l-.004 5.677 5.453.419c13.851 1.063 24.701 12.774 24.701 26.661 0 14.749-11.999 26.749-26.749 26.749z" fill="#3c96ef"></path>
                                            </g>
                                        </svg> */}
                                        <h3>Built Inside Salesforce – Secure & Compliant</h3>
                                        <p>100% native to Salesforce, ensuring enterprise-grade security with built-in compliance for HIPAA, GDPR, and SOC 2—no external servers, no vulnerabilities.</p>
                                    </Grid>
                                    <Grid item>
                                        {/* <svg viewBox="20.42 48.257 159.16 103.485" xmlns="http://www.w3.org/2000/svg" role="presentation">
                                            <g>
                                                <path d="M177.118 96.151L142.48 80.165a4.235 4.235 0 0 0-3.555 0l-34.637 15.986a4.252 4.252 0 0 0-2.464 3.849c0 1.648.967 3.159 2.463 3.85l34.638 15.986c.553.255 1.167.39 1.777.39.619 0 1.217-.131 1.778-.39l34.638-15.986c1.496-.691 2.462-2.202 2.462-3.85s-.967-3.159-2.462-3.849zM165.223 100l-24.521 11.316L116.181 100l24.52-11.316L165.223 100z" fill="#3c96ef"></path>
                                                <path d="M98.177 100a4.251 4.251 0 0 0-2.463-3.849L61.076 80.165a4.236 4.236 0 0 0-3.554 0L22.883 96.151c-1.496.691-2.463 2.202-2.463 3.849s.967 3.159 2.463 3.85l34.638 15.985a4.257 4.257 0 0 0 1.777.391c.619 0 1.216-.131 1.777-.39l34.638-15.986a4.253 4.253 0 0 0 2.464-3.85zm-14.358 0l-24.521 11.316L34.778 100l24.52-11.316L83.819 100z" fill="#3c96ef"></path>
                                                <path d="M63.585 72.333l34.638 15.985a4.257 4.257 0 0 0 1.777.391 4.21 4.21 0 0 0 1.777-.39l34.639-15.986a4.253 4.253 0 0 0 2.462-3.85 4.252 4.252 0 0 0-2.462-3.849l-34.639-15.986a4.236 4.236 0 0 0-3.554 0L63.585 64.634a4.253 4.253 0 0 0-2.463 3.849c0 1.648.966 3.159 2.463 3.85zm11.895-3.85L100 57.167l24.52 11.316L100 79.8 75.48 68.483z" fill="#3c96ef"></path>
                                                <path d="M136.417 127.667l-34.639-15.986a4.236 4.236 0 0 0-3.554 0l-34.639 15.986c-1.496.691-2.463 2.202-2.463 3.849s.967 3.159 2.463 3.85l34.638 15.985a4.257 4.257 0 0 0 1.777.391 4.21 4.21 0 0 0 1.777-.39l34.639-15.986c1.496-.691 2.462-2.202 2.462-3.85s-.966-3.158-2.461-3.849zm-11.897 3.85L100 142.833l-24.52-11.316L100 120.2l24.52 11.317z" fill="#3c96ef"></path>
                                            </g>
                                        </svg> */}
                                        <h3>Seamless Integrations & Automation</h3>
                                        <p>Powerful API-first architecture enables real-time connectivity between Salesforce, third-party apps, AI models, and legacy systems—effortless automation, zero complexity.</p>
                                    </Grid>
                                    <Grid item>
                                        {/* <svg viewBox="20.124 26.752 159.752 146.495" xmlns="http://www.w3.org/2000/svg" role="presentation">
                                            <g>
                                                <path d="M117.275 125.299c8.267-5.705 13.161-14.963 13.161-25.039 0-16.782-13.653-30.435-30.435-30.435S69.566 83.478 69.566 100.26c0 10.076 4.892 19.333 13.159 25.039-17.083 6.994-28.462 23.834-28.462 42.343v5.605h91.474v-5.605c0-18.509-11.38-35.349-28.462-42.343zm-17.274-5.814c-10.6 0-19.225-8.624-19.225-19.225 0-10.6 8.625-19.224 19.225-19.224s19.225 8.624 19.225 19.224c0 10.601-8.625 19.225-19.225 19.225zm-34.074 42.552c2.713-16.546 17.215-28.921 34.074-28.921 16.857 0 31.36 12.375 34.072 28.921H65.927z" fill="#3c96ef"></path>
                                                <path d="M100.001 62.03c9.726 0 17.639-7.913 17.639-17.639 0-9.726-7.913-17.639-17.639-17.639-9.727 0-17.64 7.913-17.64 17.639 0 9.726 7.912 17.639 17.64 17.639zm-6.429-17.639a6.435 6.435 0 0 1 6.429-6.428 6.435 6.435 0 0 1 6.428 6.428 6.435 6.435 0 0 1-6.428 6.429 6.437 6.437 0 0 1-6.429-6.429z" fill="#3c96ef"></path>
                                                <path d="M37.764 101.971c-9.727 0-17.64 7.913-17.64 17.639 0 9.727 7.913 17.639 17.64 17.639 9.726 0 17.639-7.913 17.639-17.639 0-9.726-7.913-17.639-17.639-17.639zm6.428 17.639c0 3.545-2.883 6.429-6.428 6.429s-6.429-2.884-6.429-6.429c0-3.545 2.884-6.429 6.429-6.429s6.428 2.884 6.428 6.429z" fill="#3c96ef"></path>
                                                <path d="M162.236 101.971c-9.726 0-17.639 7.913-17.639 17.639 0 9.727 7.913 17.639 17.639 17.639 9.727 0 17.64-7.913 17.64-17.639 0-9.726-7.913-17.639-17.64-17.639zm6.429 17.639a6.436 6.436 0 0 1-6.429 6.429 6.435 6.435 0 0 1-6.428-6.429 6.435 6.435 0 0 1 6.428-6.429 6.437 6.437 0 0 1 6.429 6.429z" fill="#3c96ef"></path>
                                            </g>
                                        </svg> */}
                                        <h3>Customizable & Future-Proof</h3>
                                        <p>Your business evolves—so should your technology. <span className="brand-title">Olympus-Grid&trade;</span> adapts to your needs, with flexible configurations, continuous innovation, and no limitations.</p>
                                    </Grid>
                                </Grid>
                                <Grid xs={12} md={12} lg={6}>
                                    <Grid item>
                                        {/* <svg viewBox="20.532 45.947 158.928 108.107" xmlns="http://www.w3.org/2000/svg" role="presentation">
                                            <g>
                                                <path d="M82.935 75.852l44.836 20.692a4.833 4.833 0 0 0 4.048 0l44.836-20.692a4.828 4.828 0 0 0 0-8.768l-44.836-20.692a4.826 4.826 0 0 0-4.047 0L82.935 67.083a4.828 4.828 0 0 0 0 8.769zm46.86-19.759l33.312 15.374-33.312 15.374-33.312-15.374 33.312-15.374z" fill="#3c96ef"></path>
                                                <path d="M172.608 95.616l-42.813 19.758-42.813-19.758a4.83 4.83 0 0 0-4.047 8.769l44.836 20.692a4.833 4.833 0 0 0 4.048 0l44.836-20.692a4.83 4.83 0 0 0-4.047-8.769z" fill="#3c96ef"></path>
                                                <path d="M172.608 124.149l-42.813 19.758-42.813-19.758a4.828 4.828 0 1 0-4.047 8.769l44.836 20.692a4.833 4.833 0 0 0 4.048 0l44.836-20.692a4.83 4.83 0 0 0-4.047-8.769z" fill="#3c96ef"></path>
                                                <path d="M65.095 95.171H25.368a4.829 4.829 0 1 0 0 9.658h39.727a4.829 4.829 0 1 0 0-9.658z" fill="#3c96ef"></path>
                                                <path d="M65.095 76.446H37.44a4.829 4.829 0 1 0 0 9.658h27.655a4.829 4.829 0 1 0 0-9.658z" fill="#3c96ef"></path>
                                                <path d="M65.095 113.897H49.512a4.829 4.829 0 1 0 0 9.658h15.583a4.829 4.829 0 1 0 0-9.658z" fill="#3c96ef"></path>
                                            </g>
                                        </svg> */}
                                        <h3>Serverless by Design – Fast, Efficient, Cost-Effective</h3>
                                        <p>Eliminate infrastructure headaches. <span className="brand-title">Olympus-Grid&trade;</span> scales automatically, reducing costs and increasing performance—so you can focus on innovation.</p>
                                    </Grid>
                                    <Grid item>
                                        {/* <svg viewBox="20.124 26.752 159.752 146.495" xmlns="http://www.w3.org/2000/svg" role="presentation">
                                            <g>
                                                <path d="M117.275 125.299c8.267-5.705 13.161-14.963 13.161-25.039 0-16.782-13.653-30.435-30.435-30.435S69.566 83.478 69.566 100.26c0 10.076 4.892 19.333 13.159 25.039-17.083 6.994-28.462 23.834-28.462 42.343v5.605h91.474v-5.605c0-18.509-11.38-35.349-28.462-42.343zm-17.274-5.814c-10.6 0-19.225-8.624-19.225-19.225 0-10.6 8.625-19.224 19.225-19.224s19.225 8.624 19.225 19.224c0 10.601-8.625 19.225-19.225 19.225zm-34.074 42.552c2.713-16.546 17.215-28.921 34.074-28.921 16.857 0 31.36 12.375 34.072 28.921H65.927z" fill="#3c96ef"></path>
                                                <path d="M100.001 62.03c9.726 0 17.639-7.913 17.639-17.639 0-9.726-7.913-17.639-17.639-17.639-9.727 0-17.64 7.913-17.64 17.639 0 9.726 7.912 17.639 17.64 17.639zm-6.429-17.639a6.435 6.435 0 0 1 6.429-6.428 6.435 6.435 0 0 1 6.428 6.428 6.435 6.435 0 0 1-6.428 6.429 6.437 6.437 0 0 1-6.429-6.429z" fill="#3c96ef"></path>
                                                <path d="M37.764 101.971c-9.727 0-17.64 7.913-17.64 17.639 0 9.727 7.913 17.639 17.64 17.639 9.726 0 17.639-7.913 17.639-17.639 0-9.726-7.913-17.639-17.639-17.639zm6.428 17.639c0 3.545-2.883 6.429-6.428 6.429s-6.429-2.884-6.429-6.429c0-3.545 2.884-6.429 6.429-6.429s6.428 2.884 6.428 6.429z" fill="#3c96ef"></path>
                                                <path d="M162.236 101.971c-9.726 0-17.639 7.913-17.639 17.639 0 9.727 7.913 17.639 17.639 17.639 9.727 0 17.64-7.913 17.64-17.639 0-9.726-7.913-17.639-17.64-17.639zm6.429 17.639a6.436 6.436 0 0 1-6.429 6.429 6.435 6.435 0 0 1-6.428-6.429 6.435 6.435 0 0 1 6.428-6.429 6.437 6.437 0 0 1 6.429 6.429z" fill="#3c96ef"></path>
                                            </g>
                                        </svg> */}
                                        <h3>Scales from Startup to Enterprise</h3>
                                        <p>Whether you're launching or optimizing global operations, <span className="brand-title">Olympus-Grid&trade;</span> adapts to your growth, handling millions of records without performance issues.</p>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
            </MDBox>
            {/* <MDBox className="blogs-container">
                <Container>
                    <Grid container spacing={5} flexGrow={1} alignContent="stretch">
                        <Grid item xs={12} md={6} lg={4}>
                            <BookingCard
                                image={ultimateBackendImg}
                                title="Introducing Olympus-Grid: Redefining Enterprise Architecture"
                                description='Olympus-Grid is more than a product; it’s a reimagining of how enterprise applications are built, deployed, and scaled. At its core, Olympus-Grid delivers a full-stack enterprise architecture platform designed to...'
                                footer={false}
                                link="/blog/introducing-olympus-grid"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <BookingCard
                                image={goldbergMachineImg}
                                title="The Evolution of Olympus-Grid: Perfection in Enterprise Architecture"
                                description='Over the years, my platform has undergone countless iterations, packaging architectures, prototypes, and namespaces. Each phase of its evolution brought new lessons and refined its purpose. Early versions of this platform...'
                                footer={false}
                                link="/blog/the-evolution-of-olympus-grid-perfection-in-enterprise-architecture"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <BookingCard
                                image={jokerImg}
                                title="Olympus-Grid: A Decade of Innovation, Ready for General Availability"
                                description='After more than a decade of relentless dedication and three years of meticulous development, Olympus-Grid is poised for its imminent release to general availability. This is more than a platform — it’s a transformative...'
                                footer={false}
                                link="/blog/olympus-grid-the-future-of-enterprise-architecture-is-here"
                            />
                        </Grid>
                    </Grid>
                </Container>
            </MDBox> */}
            <MDBox className="story-container">
                <Container>
                    <Grid container flexGrow={1} alignContent="stretch">
                        <Grid item xs={12} md={6} lg={8}>
                            <MDBox className="get-in-touch">
                                <h3>Our Story</h3>
                                <p><strong>A little bit about us...</strong></p>
                                <p>Founded in 2025 near Denver, Colorado, <span className="brand-title">Olympus-Grid&trade;</span> is a powerhouse in cloud and serverless software development. Led by one of the few independent Salesforce Certified Technical Architects, our global team spans North America, Europe, India, and Pakistan—focused exclusively on <span className="brand-title">Olympus-Grid&trade;</span> projects. With deep expertise, we’ve designed, built, and managed Salesforce-driven solutions worth millions, delivering innovation at scale.</p>
                                <MDButton onClick={() => onLeadModal(true)} variant="gradient" color="info" size="large">
                                    Contact
                                </MDButton>
                            </MDBox>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <MDBox
                                sx={{
                                    backgroundImage: `url(${storyImg})`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#fff"
                                }}
                            >
                            </MDBox>
                        </Grid>
                    </Grid>
                </Container>
            </MDBox>
            {
                leadModal ?
                    <LeadModal
                        open={leadModal}
                        onCancel={() => {onLeadModal(!leadModal);}}
                        onSuccess={() => {onLeadModal(!leadModal);}}
                    />
                :
                null
            }
        </MDBox>
    )
}

export default Landing;